import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import fr from './locales/fr.json';
import es from './locales/es.json';
import de from './locales/de.json';
import it from './locales/it.json';

export const SUPPORTED_LANGS = ['en', 'fr', 'es', 'de', 'it'];

export const LANG_LABELS = {
  en: 'English',
  fr: 'Français',
  es: 'Español',
  de: 'Deutsch',
  it: 'Italiano',
};

export const LANG_SHORT = {
  en: 'EN',
  fr: 'FR',
  es: 'ES',
  de: 'DE',
  it: 'IT',
};

export const LANG_LOCALE = {
  en: 'en-US',
  fr: 'fr-FR',
  es: 'es-ES',
  de: 'de-DE',
  it: 'it-IT',
};

export const COLLECTION_SLUGS = {
  en: { straight: 'straight', wavy: 'wavy', curly: 'curly' },
  fr: { straight: 'cheveux-lisses', wavy: 'cheveux-ondules', curly: 'cheveux-boucles' },
  es: { straight: 'cabello-liso', wavy: 'cabello-ondulado', curly: 'cabello-rizado' },
  de: { straight: 'glattes-haar', wavy: 'welliges-haar', curly: 'lockiges-haar' },
  it: { straight: 'capelli-lisci', wavy: 'capelli-mossi', curly: 'capelli-ricci' },
};

export function setCookie(name, value, days = 365) {
  const d = new Date();
  d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value};expires=${d.toUTCString()};path=/;SameSite=Lax`;
}

export function getCookie(name) {
  const v = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
  return v ? v.pop() : null;
}

export function formatPrice(amount, lang = 'en', currency = 'USD') {
  const locale = LANG_LOCALE[lang] || 'en-US';
  // For GBP, use en-GB locale for proper formatting
  const effectiveLocale = currency === 'GBP' ? 'en-GB' : locale;
  return new Intl.NumberFormat(effectiveLocale, {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
}

export function formatNumber(num, lang = 'en') {
  const locale = LANG_LOCALE[lang] || 'en-US';
  return new Intl.NumberFormat(locale).format(num);
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
      es: { translation: es },
      de: { translation: de },
      it: { translation: it },
    },
    fallbackLng: 'en',
    supportedLngs: SUPPORTED_LANGS,
    interpolation: { escapeValue: false },
    detection: {
      order: ['path', 'cookie', 'navigator'],
      lookupFromPathIndex: 0,
      lookupCookie: 'zelina-lang',
      caches: ['cookie'],
      cookieMinutes: 525600,
      cookieOptions: { path: '/', sameSite: 'lax' },
    },
  });

export default i18n;
